import { AGENT_REPORT_COLUMNS, type AgentReportMetrics } from 'constants/agentReporting';

interface ActivityDay {
  id: string;
  name?: string;
  metrics: AgentReportMetrics;
}
export interface AgentActivityReport {
  totals: AgentReportMetrics;
  breakdowns: { days: ActivityDay[]; providers?: ActivityDay[] };
}

// Fill dates with no recorded activity, but preserve unknown metrics on recorded days.
export function agentActivityDays(
  days: ActivityDay[],
  since?: string,
  until?: string
): ActivityDay[] {
  const sorted = [...days].sort((a, b) => a.id.localeCompare(b.id));
  if (!sorted.length) return [];
  const start = Date.parse(`${since || sorted[0].id}T00:00:00Z`);
  const end = Date.parse(`${until || sorted[sorted.length - 1].id}T00:00:00Z`);
  const count = (end - start) / 86400000 + 1;
  // Unrestricted reports can span decades; retain sparse recorded dates for those ranges.
  if (!Number.isFinite(count) || count < 1 || count > 3660) return sorted;
  const byDay = new Map(sorted.map(day => [day.id, day]));
  return Array.from({ length: count }, (_, index) => {
    const id = new Date(start + index * 86400000).toISOString().slice(0, 10);
    return (
      byDay.get(id) || {
        id,
        metrics: {
          ...Object.fromEntries(AGENT_REPORT_COLUMNS.map(column => [column, 0])),
          unknown_metric_periods: 0,
          unknown_cost_periods: 0,
          currency: 'USD',
          pricing_version: '',
        } as AgentReportMetrics,
      }
    );
  });
}
